export const GET_CONTENT_REQUEST = 'content/GET_CONTENT_REQUEST';
export const GET_CONTENT_SUCCESS = 'content/GET_CONTENT_SUCCESS';
export const GET_CONTENT_FAILURE = 'content/GET_CONTENT_FAILURE';
